import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class ExtFileDbTableDefinition extends DbTableDefinition {
  tableName = 'extFiles';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       databag LONGTEXT,
       fid LONGTEXT,
       fileextension TEXT,
       synctype TEXT,
       fileidentifier longtext,
       filecontent longtext,
       extfiletype TEXT,
       filesize INT(11),
       ownerid BIGINT(20),
       objref TEXT,
       version INT(10),
       extfileid TEXT,
       extfiletypeshortname TEXT,
       downloadStatus TEXT,
       downloadKey BIGINT(20),
       enableplanmarker BOOLEAN
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'acid',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'aclabel',
        type: 'TEXT',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'acukey',
        type: 'VARCHAR(255)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'draftOwnerEmpId',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'draftOwnerMcId',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'draftOwnerServiceJobId',
        type: 'BIGINT(20)',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'filledFormData',
        type: 'LONGTEXT',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'draftdynformid',
        type: 'BIGINT(20)',
      });
    } else {
      this.updateStatements.set(14, [
        `ALTER TABLE ${this.tableName} ADD COLUMN acid BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN aclabel TEXT;`,
        `ALTER TABLE ${this.tableName} ADD COLUMN acukey VARCHAR(255);`,
      ]);
      this.updateStatements.set(31, [
        `ALTER TABLE ${this.tableName} ADD COLUMN draftOwnerEmpId BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN draftOwnerMcId BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN filledFormData LONGTEXT;`,
      ]);
      this.updateStatements.set(33, [
        `ALTER TABLE ${this.tableName} ADD COLUMN draftdynformid BIGINT(20);`,
      ]);
      this.updateStatements.set(34, [
        `ALTER TABLE ${this.tableName} ADD COLUMN draftOwnerServiceJobId BIGINT(20);`,
      ]);
      // this.updateStatements.set(27, [
      //   `ALTER TABLE ${this.tableName} ADD COLUMN thumbDownloadStatus TEXT;`,
      //   `ALTER TABLE ${this.tableName} ADD COLUMN thumbDownloadKey BIGINT(20);`,
      // ]);
    }
  }
}
